




















































































import Vue from "vue";
import {
  required,
  integer,
  minValue,
  minLength,
  requiredIf
} from "vuelidate/lib/validators";
import dialog from "@/common/mixins/dialog";
import PromotionGroupCard from "../components/PromotionGroupCard.vue";
import {
  PromotionUpdateForm,
  PromotionItemGroupForm,
  PromotionItemStatus,
  PromotionItemForm,
  PromotionConditionPriceForm
} from "../forms/PromotionUpdateForm";
import { Shop } from "../../shop/models/Shop";
import { Channel } from "../../channel/models/Channel";
import { Item } from "../../item/models/Item";

export default Vue.extend({
  mixins: [dialog],
  components: {
    PromotionGroupCard
  },
  validations: {
    promotionUpdateForm: {
      name: { required },
      shop: { required },
      startDate: { required },
      promotionGroup: {
        channelsSelected: {
          required,
          minLength: minLength(1)
        },
        conditionItemGroups: {
          $each: {
            items: {
              required: requiredIf(function(this: any) {
                return this.isConditionTypeProduct;
              }),
              minLength: minLength(1),
              $each: {
                status: {
                  sameAs: function(status: any) {
                    return status === PromotionItemStatus.Success;
                  }
                }
              }
            }
          }
        },
        promotionItemGroups: {
          $each: {
            items: {
              required: requiredIf(function(this: any) {
                return this.isConditionTypeProduct;
              }),
              minLength: minLength(1),
              $each: {
                status: {
                  sameAs: function(status) {
                    return status === PromotionItemStatus.Success;
                  }
                }
              }
            }
          }
        },
        promotionConditionPrices: {
          $each: {
            price: { required, minValue: minValue(0) },
            promotionItemGroups: {
              $each: {
                items: {
                  required: requiredIf(function(this: any) {
                    return this.isConditionTypePrice;
                  }),
                  minLength: minLength(1),
                  $each: {
                    status: {
                      sameAs: function(status: any) {
                        return status === PromotionItemStatus.Success;
                      }
                    }
                  }
                }
              }
            }
          }
        },
        orderLimit: {
          required,
          integer,
          minValue: minValue(0)
        },
        orderItemLimitAmount: {
          required: requiredIf(function(this: any) {
            return this.promotionUpdateForm.promotionGroup.orderItemLimit;
          }),
          integer,
          minValue: minValue(1)
        }
      }
    }
  },
  data() {
    const shops: Shop[] = [];
    const channels: Channel[] = [];
    const isLoading = false;
    const promotionUpdateForm: PromotionUpdateForm = {
      name: "",
      promotionGroup: {
        channelsSelected: [],
        conditionType: "PRODUCT",
        conditionItemGroups: [{ items: [], deletedItemsId: [] }],
        promotionItemGroups: [{ items: [], deletedItemsId: [] }],
        promotionConditionPrices: [
          {
            price: 0,
            promotionItemGroups: [{ items: [], deletedItemsId: [] }],
            deletedPromotionGroupsId: []
          }
        ],
        orderLimit: 0,
        orderItemLimit: false,
        orderItemLimitAmount: null,
        promotionHold: false,
        deletedConditionItemGroupsId: [],
        deletedPromotionItemGroupsId: [],
        deletedPromotionConditonPricesId: []
      }
    };

    return {
      shops,
      channels,
      isLoading,
      promotionUpdateForm
    };
  },
  computed: {
    shopOptions() {
      return (this as any).shops;
    },
    channelOptions() {
      return (this as any).channels;
    },
    isConditionTypeProduct() {
      return (
        (this as any).promotionUpdateForm.promotionGroup.conditionType ===
        "PRODUCT"
      );
    },
    isConditionTypePrice() {
      return (
        (this as any).promotionUpdateForm.promotionGroup.conditionType ===
        "PRICE"
      );
    },
    nameError() {
      return (this as any).$v.promotionUpdateForm.name.$error
        ? "ชื่อ Promotion is required"
        : "";
    },
    shopError() {
      return (this as any).$v.promotionUpdateForm.shop.$error
        ? "ร้าน is required"
        : "";
    },
    startDateError() {
      return (this as any).$v.promotionUpdateForm.startDate.$error
        ? "วันเริ่ม is required or invalid"
        : "";
    }
  },
  async created() {
    await Promise.all([this.getShops(), this.getChannels()]);
    await this.getPromotionById(+this.$route.params.id);
  },
  methods: {
    goToPromotionViewPage() {
      this.$router.push({ name: "PromotionViewPage" });
    },
    async submit() {
      this.$v.$touch();
      if (this.$v.$invalid) return;
      const isConfirmed = await (this as any).alertConfirm(
        "Confirm to updsate promotion",
        "คุณต้องการแก้ไข Promotion หรือไม่ ?"
      );
      if (isConfirmed) {
        await this.updatePromotion();
      }
    },
    async clear() {
      this.$v.$reset();

      await this.getPromotionById(+this.$route.params.id);
    },
    async getShops() {
      try {
        const { data } = await (this as any).$dep.shopUseCase.getShops({
          perPage: 9999
        });
        this.shops = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async getChannels() {
      try {
        const { data } = await (this as any).$dep.channelUseCase.getChannels({
          perPage: 9999
        });
        this.channels = data;
      } catch (error) {
        console.log(error.response);
      }
    },
    async updatePromotion() {
      try {
        this.isLoading = true;

        const promotion = await (this as any).$dep.promotionUseCase.updatePromotion(
          +this.$route.params.id,
          this.promotionUpdateForm
        );
        if (
          await (this as any).alertSuccess("Success", "แก้ไข Promotion สำเร็จ")
        ) {
          this.goToPromotionViewPage();
        }
      } catch (error) {
        if (error.response && error.response.status === 400) {
          (this as any).alertError("Error", error.response.data.message);
        } else {
          process.env.NODE_ENV === "production"
            ? (this as any).alertError("Error", "ไม่สามารถแก้ไข Promotion ได้")
            : (this as any).alertError("Error", error);
        }
      } finally {
        this.isLoading = false;
      }
    },
    getInitCheckItem(
      itemGroups: PromotionItemGroupForm[]
    ): PromotionItemForm[] {
      const initItems: PromotionItemForm[] = [];

      itemGroups.forEach((itemGroup: PromotionItemGroupForm) => {
        itemGroup.items.forEach((item: PromotionItemForm) => {
          if (item.status === PromotionItemStatus.Init) {
            initItems.push(item);
          }
        });
      });

      return initItems;
    },
    async checkConditionItem() {
      try {
        const initItems = this.getInitCheckItem(
          this.promotionUpdateForm.promotionGroup.conditionItemGroups
        );

        const foundItems = await this.getFoundItems(initItems);

        const newCondtionItemGroups = this.promotionUpdateForm.promotionGroup.conditionItemGroups.map(
          (e: PromotionItemGroupForm) => {
            const items = this.changeItemsStatus(e, foundItems);
            return { ...e, items };
          }
        );

        this.promotionUpdateForm.promotionGroup.conditionItemGroups = newCondtionItemGroups;
      } catch (error) {
        return error;
      }
    },
    async checkPromotionItem() {
      try {
        const initItems = this.getInitCheckItem(
          this.promotionUpdateForm.promotionGroup.promotionItemGroups
        );

        const foundItems = await this.getFoundItems(initItems);

        const newPromotionItemGroups = this.promotionUpdateForm.promotionGroup.promotionItemGroups.map(
          (e: PromotionItemGroupForm) => {
            const items = this.changeItemsStatus(e, foundItems);
            return { ...e, items };
          }
        );

        this.promotionUpdateForm.promotionGroup.promotionItemGroups = newPromotionItemGroups;
      } catch (error) {
        return error;
      }
    },
    async checkConditionPriceItem() {
      try {
        let initItems: PromotionItemForm[] = [];
        this.promotionUpdateForm.promotionGroup.promotionConditionPrices.forEach(
          (condition: PromotionConditionPriceForm) => {
            initItems = initItems.concat(
              this.getInitCheckItem(condition.promotionItemGroups)
            );
          }
        );

        const foundItems = await this.getFoundItems(initItems);

        const newPromotionConditionPrices = this.promotionUpdateForm.promotionGroup.promotionConditionPrices.map(
          (e: PromotionConditionPriceForm) => {
            const promotionItemGroups = e.promotionItemGroups.map(
              (promotionItemGroup: PromotionItemGroupForm) => {
                const items = this.changeItemsStatus(
                  promotionItemGroup,
                  foundItems
                );
                return { ...promotionItemGroup, items };
              }
            );
            return { ...e, promotionItemGroups };
          }
        );

        this.promotionUpdateForm.promotionGroup.promotionConditionPrices = newPromotionConditionPrices;
      } catch (error) {
        return error;
      }
    },
    changeItemsStatus(
      promotionItemGroup: PromotionItemGroupForm,
      foundItems: Item[]
    ) {
      return promotionItemGroup.items.map((item: PromotionItemForm) => {
        if (item.status === PromotionItemStatus.Init) {
          const foundItem = foundItems.find(foundItem => {
            return foundItem.code === item.sku;
          });

          if (foundItem) {
            return {
              ...item,
              name: foundItem.name,
              status: PromotionItemStatus.Success
            };
          } else {
            return {
              ...item,
              status: PromotionItemStatus.Fail
            };
          }
        }
        return item;
      });
    },
    async checkItem(sku: string) {
      try {
        const { data } = await (this as any).$dep.itemUseCase.checkItem(
          this.promotionUpdateForm.shop,
          sku
        );
        return data;
      } catch (error) {
        return null;
      }
    },
    async getFoundItems(items: PromotionItemForm[]) {
      return (
        await Promise.all(
          items.map((e: PromotionItemForm) => {
            return this.checkItem(e.sku);
          })
        )
      ).filter(e => e);
    },
    async getPromotionById(id: number) {
      try {
        const { data } = await (this as any).$dep.promotionUseCase.getPromotion(
          id
        );
        const promotion = (this as any).$dep.promotionUseCase.presentPromtionForm(
          data
        );
        this.promotionUpdateForm = { ...promotion, promotion };
        const shop = await this.shops.find(shop => {
          return shop.id === data.shopId;
        });
        this.promotionUpdateForm = { ...this.promotionUpdateForm, shop };
      } catch (error) {
        console.log(error);
      }
    }
  }
});
